import { render, staticRenderFns } from "./template-listing.vue?vue&type=template&id=b4058ce2&scoped=true&"
import script from "./template-listing.vue?vue&type=script&lang=js&"
export * from "./template-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4058ce2",
  null
  
)

export default component.exports